<!-- 员工时间设定 -->
<template>
    <div>
    	<van-nav-bar
		  	title="员工时间设定"
			left-arrow
		  	@click-left="$router.push('/')">
		</van-nav-bar>
		<van-field
			readonly
		   
		    right-icon="arrow"
		    label="上班时间"
		    placeholder="选择上班时间"
		    @click="startTimePicker=true;"
		    />
		<van-popup v-model="startTimePicker" position="bottom">
			<van-datetime-picker
			  	type="time"
			  	:min-hour="0"
			  	:max-hour="23"
			  	@cancel="startTimePicker = false"
				@confirm=''
			/>
		</van-popup>
		<van-field
			readonly
		   
		    right-icon="arrow"
		    label="下班时间"
		    placeholder="选择下班时间"
		    @click="endTimePicker=true;"
		    />
		<van-popup v-model="endTimePicker" position="bottom">
			<van-datetime-picker
			  	type="time"
			  	:min-hour="0"
			  	:max-hour="23"
			  	@cancel="endTimePicker = false"
				@confirm=''
			/>
		</van-popup>
		<van-field
			readonly
		   	
		    right-icon="arrow"
		    label="早饭开始时间"
		    placeholder="选择开始时间"
		    @click="startBreakfast=true;"
		    />
		<van-popup v-model="startBreakfast" position="bottom">
			<van-datetime-picker
			  	type="time"
			  	:min-hour="0"
			  	:max-hour="23"
			  	@cancel="startBreakfast = false"
				
			/>
		</van-popup>
		<van-field
			readonly
		   
		    right-icon="arrow"
		    label="早饭结束时间"
		    placeholder="选择结束时间"
		    @click="endBreakfast=true;"
		    />
		<van-popup v-model="endBreakfast" position="bottom">
			<van-datetime-picker
			  	type="time"
			  	:min-hour="0"
			  	:max-hour="23"
			  	@cancel="endBreakfast = false"
	
			/>
		</van-popup>
		<van-field
			readonly
		   
		    right-icon="arrow"
		    label="午饭开始时间"
		    placeholder="选择开始时间"
		    @click="startLunch=true;"
		    />
		<van-popup v-model="startLunch" position="bottom">
			<van-datetime-picker
			  	type="time"
			  	:min-hour="0"
			  	:max-hour="23"
			  	@cancel="startLunch = false"
	
			/>
		</van-popup>
		<van-field
			readonly
		   
		    right-icon="arrow"
		    label="午饭结束时间"
		    placeholder="选择结束时间"
		    @click="endLunch=true;"
		    />
		<van-popup v-model="endLunch" position="bottom">
			<van-datetime-picker
			  	type="time"
			  	:min-hour="0"
			  	:max-hour="23"
			  	@cancel="endLunch = false"
	
			/>
		</van-popup>
		<van-field
			readonly
		   
		    right-icon="arrow"
		    label="晚饭开始时间"
		    placeholder="选择开始时间"
		    @click="startDinner=true;"
		    />
		<van-popup v-model="startDinner" position="bottom">
			<van-datetime-picker
			  	type="time"
			  	:min-hour="0"
			  	:max-hour="23"
			  	@cancel="startDinner = false"
	
			/>
		</van-popup>
		<van-field
			readonly
		   
		    right-icon="arrow"
		    label="晚饭结束时间"
		    placeholder="选择结束时间"
		    @click="endDinner=true;"
		    />
		<van-popup v-model="endDinner" position="bottom">
			<van-datetime-picker
			  	type="time"
			  	:min-hour="0"
			  	:max-hour="23"
			  	@cancel="endDinner = false"
	
			/>
		</van-popup>


    </div>
</template>
<script>
  	export default {
    	data(){
    		return{
    			startTimePicker:false,
    			endTimePicker:false,
    			startBreakfast:false,
    			endBreakfast:false,
    			startLunch:false,
    			endLunch:false,
    			startDinner:false,
    			endDinner:false
    		}
    	}
  	}
</script>
<style scoped>
	/deep/ .van-nav-bar .van-icon{
		font-size: 24px;
		color: #fff;
	}
	/deep/ .van-cell__title,/deep/ .van-field__control{
		font-size: 16px;
	}
	/deep/ .van-field__label{
		width: 130px;
	}
</style>


// WEBPACK FOOTER //
// src/Service/StaffTimeSeting.vue